import { EditorText, PostEditorPostError, PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';
import { getTotalHashes } from '../TextEditor/helpers/getTotalHashes';
import { CustomParagraph } from 'models/slate-editor';
import { severityResolver } from './helpers/severity-resolver';
import { initialParagraph } from '../states/initial';

const getInvalidVariations = (texts: EditorText[], firstComment: CustomParagraph[]) => {
  const initial: number[] = [];
  return texts.reduce((prev, current) => {
    const { id } = current;
    const [hastagsInText, hastagsInFirstComment] = getTotalHashes([current], firstComment);
    return hastagsInText + hastagsInFirstComment > 30 ? [...prev, id] : prev;
  }, initial);
};

export const instagramHashtagLimit = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity
): PostEditorPostErrors => {
  const { customizeContentPerProfile, profiles } = postGroup;
  let results: PostEditorPostError[] = [];
  if (customizeContentPerProfile) {
    postGroup.posts.forEach(post => {
      const { texts, firstComment, shouldShowFirstComment } = post.content;

      const selectedSocialProfiles = profiles.filter(
        p => p.__typename === 'InstagramSocialProfile' && p.profileId === post.customizedProfileId
      );
      const invalidVariationsIds = getInvalidVariations(
        texts,
        shouldShowFirstComment ? firstComment : [initialParagraph()]
      );
      if (selectedSocialProfiles.length && invalidVariationsIds.length) {
        const errors = invalidVariationsIds.map(variationId => ({
          profileId: post.customizedProfileId,
          variationId: variationId,
          severity: severityResolver(post, severity),
          selectedSocialProfiles,
          message: PostEditorValidationMessages.instagramHashtagLimit
        }));
        results = [...results, ...errors];
      }
    });
  } else {
    const { texts, firstComment, shouldShowFirstComment } = postGroup.groupPostAttributes.content;
    const selectedSocialProfiles = profiles.filter(p => p.__typename === 'InstagramSocialProfile');

    const invalidVariationsIds = getInvalidVariations(
      texts,
      shouldShowFirstComment ? firstComment : [initialParagraph()]
    );
    if (selectedSocialProfiles.length && invalidVariationsIds.length) {
      const errors = invalidVariationsIds.map(variationId => ({
        profileId: null,
        variationId: variationId,
        severity: severityResolver(postGroup.groupPostAttributes, severity),
        selectedSocialProfiles,
        message: PostEditorValidationMessages.instagramHashtagLimit
      }));

      results = [...results, ...errors];
    }
  }
  return results.length ? results : false;
};
